module.exports = __webpack_public_path__ + "static/img/4.2989eb6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/trainPlan/10sportDesc/4.svg
// module id = 596u
// module chunks = 0